<template>
  <div class="bbp-request-form" v-if="clientsLoaded && usersLoaded">
    <BBPForm @close="closeForm"
             @save="saveForm"
             :btnTextRight="request.id ? 'SAVE' : 'ADD'"
             :defaultModel="updateBody"
             :title="titleForm"
             :inputs="inputs"
             :project="request"
    />
  </div>
</template>

<script>
import ClientApi from '@/api/Clients/api'
import UserApi from '@/api/Users/api'
import RequestApi from '@/api/Requests/api'
import BBPForm from '@/components/Main/BBPForm/BBPForm'
import {find, findIndex, get, orderBy} from 'lodash'
import requestInputs from '@/constants/InputsSettings/requestInputs'
import setRequestBody from '@/mixin/setRequestBody'
import filterByDepartment from '@/mixin/filterByDepartment'
import { PM_REQUEST_TAB_ID } from '@/constants/tabs/requestsTabs'

export default {
  name: 'RequestForm',
  props: ['request', 'activeTab'],
  mixins: [setRequestBody, filterByDepartment],
  components: {
    BBPForm
  },
  data () {
    return {
      clientsLoaded: false,
      usersLoaded: false,
      inputs: requestInputs,
      updateBody: {
        dateStart: new Date()
      }
    }
  },
  computed: {
    titleForm () {
      return this.request.id ? this.request.name : 'Add request'
    },
    userInfo () {
      return this.$store.getters.userInfo
    },
    clientsListProjects: {
      get () {
        return this.$store.getters.clientsListProjects
      },
      set (data) {
        this.$store.dispatch('setClientsListProjects', data)
      }
    },
    usersListProjects: {
      get () {
        return this.$store.getters.usersListProjects
      },
      set (data) {
        this.$store.dispatch('setUsersListProjects', data)
      }
    },
    requestsList: {
      get () {
        return this.$store.getters.requestsList
      },
      set (data) {
        this.$store.dispatch('setRequestsList', data)
      }
    },
    listOfRequestTags: {
      get () {
        return this.$store.getters.listOfRequestTags
      },
      set (data) {
        this.$store.dispatch('setListOfRequestTags', data)
      }
    }
  },
  methods: {
    updateInputsDefault () {
      const { id } = this.request
      const item = this.inputs.find((el) => el.model === 'commentText')
      item.show = id
      item.required = !id

      const type = this.inputs.find((el) => el.isType)
      type.label = this.activeTab === PM_REQUEST_TAB_ID ? 'Project manager' : 'Business consultant'
      type.model = this.activeTab === PM_REQUEST_TAB_ID ? 'projectManager' : 'businessConsultant'
    },
    closeForm () {
      this.$emit('close')
    },
    saveForm (val) {
      const commentUsers = get(this.request, 'commentUsers', [])
      val.commentUsers = commentUsers
      const request = this.setRequestBody(val, this.activeTab)
      this.saveRequest(request)
    },
    saveRequest (request) {
      const requestId = get(this.request, 'id', '')
      if (requestId) request.id = requestId
      this.$emit('loader', true)
      const saveFunc = requestId ? RequestApi.editRequest : RequestApi.createRequest
      saveFunc(request)
        .then(({ data }) => {
          const index = findIndex(this.requestsList, {id: data.id})
          if (index === -1) {
            this.requestsList.push(data)
            this.$emit('updateTotalValue', -1, data)
            this.requestsList = orderBy(this.requestsList, ['dateStart'], ['desc'])
          } else {
            this.$emit('updateTotalValue', index, data)
            this.requestsList.splice(index, 1, data)
          }
          this.$emit('loader', false)
          this.closeForm()
        })
        .catch(err => {
          this.$emit('loader', false)
          console.error(err)
        })
    },
    async getClientsSelect () {
      if (this.clientsListProjects.length) {
        this.setClientsInputs()
        return
      }
      try {
        const { data } = await ClientApi.getClientsSelect({contactType: 'contactType[]=1'})
        this.clientsListProjects = data
        this.setClientsInputs()
      } catch (err) {
        console.error(err)
      }
    },
    async getUsersListSelect () {
      if (this.usersListProjects.length) {
        this.setUsersInputs()
        this.loaderRun = false
        return
      }
      try {
        const { data } = await UserApi.getUsersListSelect({})
        this.usersListProjects = data
        this.setUsersInputs()
        this.loaderRun = false
      } catch (err) {
        this.loaderRun = false
        console.error(err)
      }
    },
    setUsersInputs () {
      const managers = this.inputs.find((el) => el.isType) || {}
      const commentText = find(this.inputs, {model: 'commentText'}) || {}
      managers.options = this.sortUsersByDepartment(this.usersListProjects, this.activeTab)
      commentText.options = this.usersListProjects
      this.usersLoaded = true
    },
    setClientsInputs () {
      const clientInput = find(requestInputs, {model: 'client'}) || {}
      clientInput.options = this.clientsListProjects
      this.clientsLoaded = true
    },
    setTagsInputs () {
      const tagsInput = requestInputs.find((el) => el.model === 'tags')
      tagsInput.options = this.listOfRequestTags
    }
  },
  beforeMount () {
    this.updateInputsDefault()
    if (this.request && this.request.id) this.updateBody = this.request
    this.getUsersListSelect()
    this.getClientsSelect()
    this.setTagsInputs()
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../sass/variables";
  @import "../../../sass/mixins";

  .bbp-request-form {
    @include global-font;
    display: grid;
    width: 521px;
    height: 100%;
  }

</style>



// WEBPACK FOOTER //
// src/components/Requests/RequestForm/RequestForm.vue